import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../config/AuthContext';

interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { isLoggedIn } = useContext(AuthContext);
    const location = useLocation();

    // Double check with localStorage to avoid race conditions or state delays
    const token = localStorage.getItem('authToken');

    if (!isLoggedIn && !token) {
        // Redirect to login page, but save the current location they were trying to go to
        // so we can redirect them back after they login (optional, but good UX)
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
